import React from 'react';
import { toRem } from '../../../ui';

export const Logo = ({ size }: { size?: any }) => {
    const props = {
        width: !!size ? toRem(size) : undefined,
        height: !!size ? toRem(size) : undefined,
    };
    return <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
        <g fill="currentColor">
            <path d="M3.59 19a.56.56 0 0 1 0-.61C7.21 12.33 6 3.75 6 3.67a.53.53 0 0 1 .16-.48.6.6 0 0 1 .51-.19c8.61 1.21 13.62 0 13.67 0a.59.59 0 0 1 .7.35c3.84 8.95-1.04 18.91-1.29 19.33a.59.59 0 0 1-.53.32c-12.8 0-15.54-3.86-15.63-4zM7.25 4.28c.2 2.24.54 9-2.47 14.3.85.79 4.25 3.2 14.07 3.26.79-1.73 4.23-10.1 1.28-17.57a42.52 42.52 0 0 1-12.88.01z" />
            <ellipse cx="15.43" cy="11.13" rx="1.26" ry="1.26" />
            <ellipse cx="11.64" cy="11.13" rx="1.26" ry="1.26" />
            <path d="M8.91 12.85h-.08a.49.49 0 0 0-.51.46 5.25 5.25 0 0 0 3.93 5.41A5.32 5.32 0 0 0 18.74 15a.52.52 0 0 0-.44-.59z" />
        </g>
    </svg>;
};

